import { getColor, mode, transparentize } from '@chakra-ui/theme-tools';

function variantSolidLight(props) {
  var {
    colorScheme: c,
    theme
  } = props;
  var darkBg = transparentize(c + ".200", 0.16)(theme);
  return {
    bg: mode(c + ".500", darkBg)(props),
    color: mode('white', 'whiteAlpha.800')(props)
  };
}

function variantSolidDark(props) {
  var {
    colorScheme: c,
    theme
  } = props;
  var dark = transparentize(c + ".900", 0.6)(theme);
  return {
    bg: mode(c + ".700", dark)(props),
    color: mode('white', 'whiteAlpha.800')(props)
  };
}

function variantOutlineDark(props) {
  var {
    colorScheme: c,
    theme
  } = props;
  var darkColor = transparentize(c + ".700", 0.8)(theme);
  var lightColor = getColor(theme, c + ".700");
  var color = mode(lightColor, darkColor)(props);
  return {
    color,
    boxShadow: "inset 0 0 0px 1px " + color
  };
}

function variantOutlineLight(props) {
  var {
    colorScheme: c,
    theme
  } = props;
  var darkColor = transparentize(c + ".200", 0.8)(theme);
  var lightColor = getColor(theme, c + ".500");
  var color = mode(lightColor, darkColor)(props);
  return {
    color,
    boxShadow: "inset 0 0 0px 1px " + color
  };
}

function variantUserBadge(props) {
  var {
    colorScheme: c
  } = props;
  return {
    paddingLeft: {
      base: '0',
      sm: '1.125rem'
    },
    paddingRight: '0',
    height: 'auto',
    lineHeight: 'normal',
    color: mode('black', 'gray.900')(props),
    borderRadius: '2.0rem',
    borderColor: 'gray.400',
    bg: 'transparent',
    ':active, :focus': {
      borderColor: mode(c + ".800", c + ".400")(props),
      color: mode(c + ".500", c + ".400")(props),
      bg: 'transparent'
    },
    _hover: {
      borderColor: mode(c + ".200", c + ".400")(props),
      color: mode(c + ".200", c + ".400")(props),
      bg: 'transparent'
    },
    '> span': {
      mx: 1,
      my: 1
    }
  };
}

var variants = {
  'solid-light': props => ({
    container: variantSolidLight(props)
  }),
  'solid-dark': props => ({
    container: variantSolidDark(props)
  }),
  'outline-dark': props => ({
    container: variantOutlineDark(props)
  }),
  'outline-light': props => ({
    container: variantOutlineLight(props)
  }),
  'user-badge': props => ({
    container: variantUserBadge(props),
    label: {
      display: {
        base: 'none',
        sm: 'flex'
      },
      flexDirection: 'column',
      textAlign: 'right'
    }
  })
};
var baseStyleContainer = {
  fontWeight: 700,
  lineHeight: 1.43,
  outline: 0,
  _focus: {
    boxShadow: 'none'
  }
};
var baseStyle = {
  container: baseStyleContainer,
  label: {
    lineHeight: 1.43
  },
  closeButton: {
    _focus: {
      boxShadow: 'none'
    }
  }
};
var defaultProps = {
  colorScheme: 'brand',
  variant: 'solid-light'
};
export default {
  baseStyle,
  defaultProps,
  variants
};
//# sourceMappingURL=Tag.js.map